<footer class="bg-black pt-16 pb-8 relative overflow-hidden">
  <!-- Background subtle gradient -->
  <div class="absolute inset-0 bg-gradient-to-b from-dark-blue/10 to-transparent opacity-30"></div>

  <div class="container mx-auto px-4 md:px-6 relative z-10">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-6 mb-12">
      <!-- Company info -->
      <div class="lg:col-span-1">
        <a class="inline-flex items-center mb-6" href="#">
          <img alt="" class="h-8 w-auto" src="logo.webp">
          <!-- Animated AI Music Icon -->
          <div class="ml-2 flex items-center">
            <svg class="w-6 h-6" fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <!-- AI Brain outline -->
              <path class="ai-brain-footer"
                    d="M24 8c-6.627 0-12 5.373-12 12 0 1.5.3 3 .8 4.3L8 28c-1.1 0-2 .9-2 2s.9 2 2 2h4.8c1.5 2.5 4.1 4.3 7.2 4.8V40c0 1.1.9 2 2 2s2-.9 2-2v-3.2c3.1-.5 5.7-2.3 7.2-4.8H36c1.1 0 2-.9 2-2s-.9-2-2-2l-4.8-3.7c.5-1.3.8-2.8.8-4.3 0-6.627-5.373-12-12-12z"
                    fill="none" opacity="0.7" stroke="url(#footerGradient1)" stroke-width="2"/>

              <!-- Animated sound waves -->
              <g class="sound-waves-footer">
                <path class="wave-footer wave-footer-1" d="M24 2c2-2 2-4 0-6" fill="none"
                      stroke="url(#footerGradient2)" stroke-linecap="round" stroke-width="2"/>
                <path class="wave-footer wave-footer-2" d="M46 24c2-2 4-2 6 0" fill="none"
                      stroke="url(#footerGradient2)" stroke-linecap="round" stroke-width="2"/>
                <path class="wave-footer wave-footer-3" d="M24 46c-2 2-2 4 0 6" fill="none"
                      stroke="url(#footerGradient2)" stroke-linecap="round" stroke-width="2"/>
                <path class="wave-footer wave-footer-4" d="M2 24c-2 2-4 2-6 0" fill="none"
                      stroke="url(#footerGradient2)" stroke-linecap="round" stroke-width="2"/>
              </g>

              <!-- Musical notes -->
              <g class="musical-notes-footer">
                <circle class="note-footer note-footer-1" cx="39" cy="9" fill="url(#footerGradient3)" r="1.5"/>
                <circle class="note-footer note-footer-2" cx="39" cy="39" fill="url(#footerGradient3)" r="1.5"/>
                <circle class="note-footer note-footer-3" cx="9" cy="39" fill="url(#footerGradient3)" r="1.5"/>
                <circle class="note-footer note-footer-4" cx="9" cy="9" fill="url(#footerGradient3)" r="1.5"/>
              </g>

              <!-- Gradient definitions -->
              <defs>
                <linearGradient id="footerGradient1" x1="0%" x2="100%" y1="0%" y2="100%">
                  <stop offset="0%" style="stop-color:#00a2ff"/>
                  <stop offset="100%" style="stop-color:#ff0080"/>
                </linearGradient>
                <linearGradient id="footerGradient2" x1="0%" x2="100%" y1="0%" y2="0%">
                  <stop offset="0%" style="stop-color:#00a2ff"/>
                  <stop offset="100%" style="stop-color:#ff0080"/>
                </linearGradient>
                <linearGradient id="footerGradient3" x1="0%" x2="100%" y1="0%" y2="100%">
                  <stop offset="0%" style="stop-color:#ff0080"/>
                  <stop offset="100%" style="stop-color:#00a2ff"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
        </a>
        <p class="text-white/70 text-sm mb-6">
          Revolutionizing visual-to-song matching with state-of-the-art AI technology for businesses and content
          creators.
        </p>
      </div>

      <!-- Company -->
      <div>
        <h3 class="text-white font-bold mb-4">Company</h3>
        <ul class="space-y-2">
          <!--          <li><a class="text-white/70 hover:text-electric-blue transition-colors text-sm"-->
          <!--                 href="https://www.mypart.net/blog" target="_blank">Blog</a></li>-->
          <li><a class="text-white/70 hover:text-electric-blue transition-colors text-sm"
                 href="https://www.mypart.ai/contact" target="_blank">Contact</a></li>
        </ul>
      </div>

      <!-- Legal -->
      <div>
        <h3 class="text-white font-bold mb-4">Legal</h3>
        <ul class="space-y-2">
          <!--          <li><a class="text-white/70 hover:text-electric-blue transition-colors text-sm"-->
          <!--                 href="https://www.mypart.net/privacy" target="_blank">Terms</a></li>-->
          <li><a class="text-white/70 hover:text-electric-blue transition-colors text-sm"
                 href="https://www.mypart.ai/privacy-policy" target="_blank">Privacy</a></li>
        </ul>
      </div>

      <!-- Contact -->
      <div>
        <h3 class="text-white font-bold mb-4">Contact</h3>
        <ul class="space-y-3">
          <li class="flex items-start">
            <svg class="h-5 w-5 text-electric-blue mr-2 shrink-0" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"/>
            </svg>
            <a class="text-white/70 hover:text-electric-blue transition-colors text-sm"
               href="mailto:demo&#64;mypart.com">demo&#64;mypart.com</a>
          </li>
          <li>
            <p class="text-white/70 text-sm mb-2">Social Media:</p>
            <ul class="space-y-2">
              <!--              <li>-->
              <!--                <a class="text-white/70 hover:text-electric-blue transition-colors text-sm flex items-center"-->
              <!--                   href="https://x.com/MyPart/" target="_blank">-->
              <!--                  <svg class="h-4 w-4 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
              <!--                    <path-->
              <!--                        d="M22 5.8a8.7 8.7 0 0 1-2.5.7 4.3 4.3 0 0 0 1.9-2.4c-.8.5-1.8.9-2.7 1a4.3 4.3 0 0 0-7.4 4A12.3 12.3 0 0 1 1.7 4.2a4.3 4.3 0 0 0 1.3 5.8c-.7 0-1.3-.2-2-.5v.1c0 2 1.5 3.8 3.5 4.2a4.3 4.3 0 0 1-2 .1 4.3 4.3 0 0 0 4 3 8.7 8.7 0 0 1-5.4 1.9H0a12.3 12.3 0 0 0 6.7 2c8 0 12.5-6.8 12.5-12.6v-.6c.9-.6 1.6-1.4 2.2-2.3"/>-->
              <!--                  </svg>-->
              <!--                  X (formerly Twitter)-->
              <!--                </a>-->
              <!--              </li>-->
              <li>
                <a class="text-white/70 hover:text-electric-blue transition-colors text-sm flex items-center"
                   href="https://il.linkedin.com/company/mypart-ltd." target="_blank">
                  <svg class="h-4 w-4 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M20.4 0H3.6C1.6 0 0 1.6 0 3.6v16.8c0 2 1.6 3.6 3.6 3.6h16.8c2 0 3.6-1.6 3.6-3.6V3.6c0-2-1.6-3.6-3.6-3.6zM7 20h-3V9h3v11zm-1.5-12.8c-1 0-1.8-.8-1.8-1.7s.8-1.7 1.8-1.7 1.8.8 1.8 1.7-.8 1.7-1.8 1.7zM20 20h-3v-5.6c0-3.4-4-3.1-4 0V20h-3V9h3v1.8c1.4-2.6 7-2.8 7 2.5V20z"/>
                  </svg>
                  LinkedIn
                </a>
              </li>
              <li>
                <a class="text-white/70 hover:text-electric-blue transition-colors text-sm flex items-center"
                   href="https://www.instagram.com/mypartofficial/" target="_blank">
                  <svg class="h-4 w-4 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.2 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.2.4.4 1 .4 2.2.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.9c-.1 1.2-.2 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.2-1 .4-2.2.4-1.3.1-1.6.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.2-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.2-.4-.4-1-.4-2.2-.1-1.3-.1-1.6-.1-4.8 0-3.2 0-3.6.1-4.9.1-1.2.2-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.2 1-.4 2.2-.4 1.3-.1 1.6-.1 4.9-.1zm0-2.2c-3.3 0-3.7 0-4.9.1-1.3.1-2.2.3-2.9.5-.8.3-1.4.7-2.1 1.4-.7.7-1.1 1.3-1.4 2.1-.3.8-.5 1.6-.5 2.9-.1 1.3-.1 1.7-.1 5s0 3.7.1 4.9c.1 1.3.3 2.2.5 2.9.3.8.7 1.4 1.4 2.1.7.7 1.3 1.1 2.1 1.4.8.3 1.6.5 2.9.5 1.3.1 1.7.1 5 .1s3.7 0 4.9-.1c1.3-.1 2.2-.3 2.9-.5.8-.3 1.4-.7 2.1-1.4.7-.7 1.1-1.3 1.4-2.1.3-.8.5-1.6.5-2.9.1-1.3.1-1.7.1-5s0-3.7-.1-4.9c-.1-1.3-.3-2.2-.5-2.9-.3-.8-.7-1.4-1.4-2.1-.7-.7-1.3-1.1-2.1-1.4-.8-.3-1.6-.5-2.9-.5-1.3-.1-1.7-.1-5-.1z"/>
                    <path
                        d="M12 5.8c-3.4 0-6.2 2.8-6.2 6.2s2.8 6.2 6.2 6.2 6.2-2.8 6.2-6.2-2.8-6.2-6.2-6.2zm0 10.2c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"/>
                    <circle cx="18.4" cy="5.6" r="1.4"/>
                  </svg>
                  Instagram
                </a>
              </li>
              <li>
                <a class="text-white/70 hover:text-electric-blue transition-colors text-sm flex items-center"
                   href="https://www.youtube.com/mypartofficial" target="_blank">
                  <svg class="h-4 w-4 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                  YouTube
                </a>
              </li>
              <li>
                <a class="text-white/70 hover:text-electric-blue transition-colors text-sm flex items-center"
                   href="https://www.tiktok.com/@mypartofficial" target="_blank">
                  <svg class="h-4 w-4 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-.88-.05A6.33 6.33 0 005.76 20.5a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1.8-.5z"/>
                  </svg>
                  TikTok
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!-- Divider -->
    <div class="border-t border-white/10 pt-8 mt-8">
      <div class="flex flex-col md:flex-row justify-between items-center">
        <p class="text-white/50 text-sm mb-4 md:mb-0">&copy; 2025 MyPart AI. All rights reserved.</p>
        <div class="flex space-x-6">
          <a class="text-white/50 hover:text-electric-blue text-sm" href="https://www.mypart.ai/privacy-policy"
             target="_blank">Privacy Policy</a>
          <!--          <a class="text-white/50 hover:text-electric-blue text-sm" href="https://www.mypart.ai/privacy"-->
          <!--             target="_blank">Terms of Service</a>-->
        </div>
      </div>
    </div>
  </div>
</footer>
